/**
 * Product Builder — AI Text global shim (PB-AIT-9).
 * Runtime lives in pb-ai-text-runtime.js (ES module); this attaches window.PBAiText for hydrate/cart paths.
 */
import {
  init,
  initWrap,
  activateWrap,
  syncInFlightJob,
  rehydrateWrap,
  validateStep,
  getFieldReadiness,
  flushWrapFromDom,
  flushAllFromDom,
  runGenerationForWrap,
} from '@theme/pb-ai-text-runtime';

if (typeof window !== 'undefined') {
  window.PBAiText = {
    init,
    initWrap,
    activateWrap,
    syncInFlightJob,
    rehydrateWrap,
    validateStep,
    getFieldReadiness,
    flushWrapFromDom,
    flushAllFromDom,
    runGenerationForWrap,
  };
}
